<template>
  <div class="wrapper">
    <div>
      <transition name="fade" mode="out-in">
        <h2 :key="'site'+currentSite" v-if="currentSite">{{ currentSiteDisplayName }}</h2>
      </transition>
      <transition name="fade" mode="out-in">
        <h2 key="site-fallback" v-if="!currentSite">AdSize Prediction</h2>
      </transition>
    </div>
    <Dropdown
        :options="dropdownVals"
        v-on:selected="validateSelection"
        :disabled="false"
        name="sites"
        :maxItem="dropdownVals.length"
        placeholder="Bitte eine Seite auswählen">>
    </Dropdown>
    <transition name="fade" mode="out-in">
      <div :key="'site-'+currentSite" v-if="currentSite" class="zones">
        <div class="toggle">
          <ToggleButton :values="options" @click="changeOption" :default="option"></ToggleButton>
        </div>
        <div key="site-slider" class="site-slider">
          <div class="slider-header">Anteil der Übereinstimmungen mit den Predictions anhand der gesammelten Daten</div>
          <div class="slider-wrapper">
            <RangeSlider @input="updateInitial" :initial="siteLimit"></RangeSlider>
          </div>
          <AdaButton width="250px" icon="icon-save"
                     class="save"
                     title="Speichern" type="grey" @click="saveLimit">
          </AdaButton>
        </div>
        <transition name="fade" mode="out-in">
          <div v-if="jsonDataReady" :key="'charts-'+currentSite">
            <div class="zone" v-for="(value,name, index) in currentJson" :key="'zone-'+index">
              <h4 class="zone-header">{{ name }}</h4>
              <div class="zone-items">
                <div class="chart-wrapper">
                  <LineChart unit="px" class="chart-wrapper"
                             title="Predictions"
                             :labels="getPredictions(name).labels"
                             :data="getPredictions(name).data"
                             type="big"></LineChart>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <div key="loader" v-if="!jsonDataReady">
            <dot-loader class="loader"></dot-loader>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import Dropdown from 'vue-simple-search-dropdown';
import {RepositoryFactory} from '../../scripts/RepositoryFactory';
import LineChart from "@/components/charts/LineChart";
import AdaButton from "@/components/buttons/AdaButton";
import RangeSlider from "@/components/slider/RangeSlider";
import ToggleButton from "@/components/buttons/ToggleButton";

const PredictionRepository = RepositoryFactory.get('predictions');
const LimitRepository = RepositoryFactory.get('limits');

export default {
  name: "Prediction",
  components: {ToggleButton, RangeSlider, AdaButton, LineChart, Dropdown},
  data() {
    return {
      options: ["Slots", "Zones"],
      option: "Slots",
      sites: [],
      dropdownVals: [],
      currentSite: null,
      currentSiteDisplayName: null,
      json: null,
      jsonSitetypes: null,
      jsonNoLimit: null,
      jsonNoLimitSitetypes: null,
      jsonDataReady: false,
      siteLimit: 70,
      siteLimitId: 70
    }
  },
  mounted() {
    this.initSites();
  },
  computed: {
    currentJson() {
      return this.option === "Slots" ? this.jsonSitetypes : this.json;
    },
    currentNoLimitJson() {
      return this.option === "Slots" ? this.jsonNoLimitSitetypes : this.jsonNoLimit;
    }
  },
  methods: {
    async initSites() {
      const {data} = await PredictionRepository.getSites();
      this.sites = data;
      for (let i = 0; i < this.sites.length; i++) {
        this.dropdownVals.push({
          name: this.sites[i]['displayName'],
          id: this.sites[i]['name'],
          limit: this.sites[i]['limit'],
          limit_id: this.sites[i]['limit_id']
        })
      }
      let input = this.$el.querySelector('input');
      if (input && input.classList.contains('dropdown-input')) {
        input.setAttribute("autocomplete", "off")
      }
    },
    getSiteTypeJson(json) {
      let ret = {};
      for (let zone in json) {
        for (let sitetype in json[zone]) {
          if (typeof ret[sitetype] === 'undefined') {
            ret[sitetype] = {};
          }
          ret[sitetype][zone] = json[zone][sitetype];
        }
      }
      return ret;
    },
    validateSelection(selection) {
      this.currentSite = selection.id;
      this.currentSiteDisplayName = selection.name;
      this.siteLimit = selection.limit;
      this.siteLimitId = selection.limit_id;
      this.fetchJsons()
    },
    async fetchJsons() {
      if (typeof this.currentSite !== 'undefined') {
        this.jsonDataReady = false;
        await this.getSitePrediction();
        await this.getNoLimitSitePrediction();
        this.jsonDataReady = true;
      }
    },
    getPredictions(zone) {
      let predictions = {labels: [], data: []};
      let slots = this.currentJson[zone];
      let datasetJson = {
        data: [],
        label: 'anteilige Prediction',
        borderColor: '#00b6ed',
        pointBackgroundColor: '#00b6ed',
        backgroundColor: 'rgba(0, 182, 237,0.1)',
        pointBorderWidth: 5,
        borderWidth: 2
      };
      let datasetJsonNoLimit = {
        data: [],
        label: '100%-ige Prediction',
        borderColor: '#752b77',
        pointBackgroundColor: '#752b77',
        backgroundColor: 'rgba(117, 43, 119,0.1)'
      };
      for (let slot in slots) {
        if (predictions.labels.indexOf(slot) === -1) {
          predictions.labels.push(slot);
        }
        datasetJson.data.push(slots[slot]['height']);
      }
      slots = this.currentNoLimitJson[zone];
      for (let slot in slots) {
        if (predictions.labels.indexOf(slot) === -1) {
          predictions.labels.push(slot);
        }
        datasetJsonNoLimit.data.push(slots[slot]['height']);
      }
      predictions.data.push(datasetJson);
      predictions.data.push(datasetJsonNoLimit);
      return predictions;
    },
    async getSitePrediction() {
      const {data} = await PredictionRepository.getSitePrediction(this.currentSite, this.siteLimit,null);
      this.json = data.result;
      this.jsonSitetypes = this.getSiteTypeJson(data.result);
    },
    async getNoLimitSitePrediction() {
      const {data} = await PredictionRepository.getSitePrediction(this.currentSite, 100,true);
      this.jsonNoLimit = data.result;
      this.jsonNoLimitSitetypes = this.getSiteTypeJson(data.result);
    },
    async saveLimit() {
      let success = true;
      if (typeof this.siteLimitId !== 'undefined' && this.siteLimitId !== null) {
        const {data} = await LimitRepository.update(this.siteLimitId, {
          table: 'adprediction_' + this.currentSite,
          limit: this.siteLimit
        });
        success = data.status === 'updated';
      } else {
        const {data} = await LimitRepository.create({table: 'adprediction_' + this.currentSite, limit: this.siteLimit});
        success = data.status === 'created';
      }
      if (success) {
        this.$noty.success('Änderungen erfolgreich')
      } else {
        this.$noty.error('Es ist ein Fehler aufgetreten')
      }

    },
    updateInitial(val) {
      this.siteLimit = val;
      this.fetchJsons();
    },
    changeOption(newOption) {
      this.option = newOption;
    }
  }
}
</script>

<style lang="scss">

.wrapper {
  width: 90%;
  margin: auto;
  text-align: center;
}

.dropdown {
  width: 500px;
}

.dropdown-input, .dropdown-content, .dropdown-item {

  font-size: .9em !important;
  text-align: center !important;
  width: 500px !important;
  max-width: unset !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}


.chart-wrapper {
  margin: auto;
  width: 90%;
  padding: 1rem;
}

.zones {
  text-align: left;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.zone {
  text-transform: uppercase;
  background-color: #F2F2F4;
}

.zone-items {
  display: flex;
  padding: 1rem;
  align-items: center;
}

.zone-header {
  padding: 1rem;
  background-color: #fff;
}

.rs-handle {
  background-color: #fff;
}

.save {
  width: 250px;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.slider-header {
  width: 500px;
}

.site-slider {
  margin: auto;
  width: 500px;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 400px;
}

.toggle {
  margin: auto;
  width: 500px;
  margin-bottom: 2rem;
}

</style>